import { render } from "./Dashboard-EIS-Utama.vue?vue&type=template&id=e458c946"
import script from "./Dashboard-EIS-Utama.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Utama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__